import { render, staticRenderFns } from "./MyprofilePreview.vue?vue&type=template&id=18361fa4&scoped=true"
import script from "./MyprofilePreview.vue?vue&type=script&lang=js"
export * from "./MyprofilePreview.vue?vue&type=script&lang=js"
import style0 from "./MyprofilePreview.vue?vue&type=style&index=0&id=18361fa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18361fa4",
  null
  
)

export default component.exports